(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ip-buy"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Estimated delivery window in Israeli business days (Sunday to Thursday), counted from tomorrow.
    const addBusinessDays = (from, days) => {
      const d = new Date(from);
      let left = days;
      while (left > 0) {
        d.setDate(d.getDate() + 1);
        const day = d.getDay();
        if (day !== 5 && day !== 6) left -= 1;
      }
      return d;
    };
    const fmt = new Intl.DateTimeFormat('he-IL', { weekday: 'long', day: 'numeric', month: 'numeric' });
    document.querySelectorAll('[data-ipx-eta]').forEach((el) => {
      const min = parseInt(el.getAttribute('data-min'), 10);
      const max = parseInt(el.getAttribute('data-max'), 10);
      const out = el.querySelector('[data-ipx-eta-text]');
      if (!min || !max || !out) return;
      const now = new Date();
      out.textContent = `${fmt.format(addBusinessDays(now, min))} ל${fmt.format(addBusinessDays(now, max))}`;
      el.hidden = false;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
